import styled from '@emotion/styled'
import { Card, Flex, Typography } from 'antd'

import { useMeetingContext } from '../../hooks'

const { Text } = Typography

const StyledTitle = styled(Text)`
  font-size: 18px;
`

const StyledText = styled(Text)`
  font-size: 22px;
  font-weight: bold;
`

const StyledSmallTitle = styled(Text)`
  font-size: 14px;
`

const StyledSmallText = styled(Text)`
  font-size: 14px;
`

const NormalCard = ({
  title,
  value,
}: {
  title: React.ReactNode
  value: React.ReactNode
}) => {
  return (
    <Card title={<StyledTitle>{title}</StyledTitle>}>
      <StyledText>{value}</StyledText>
    </Card>
  )
}

const SmallCard = ({
  title,
  value,
}: {
  title: React.ReactNode
  value: React.ReactNode
}) => {
  return (
    <Card
      styles={{
        header: { padding: '0.5rem 1rem' },
        body: { padding: '0.5rem 1rem' },
      }}
      title={<StyledSmallTitle>{title}</StyledSmallTitle>}
    >
      <StyledSmallText>{value}</StyledSmallText>
    </Card>
  )
}

type Props = {
  isSmall?: boolean
}

export const MeetingInfo = ({ isSmall = false }: Props) => {
  const { information } = useMeetingContext()
  const items = [
    { title: 'Hotel Name', value: information?.property },
    { title: 'Language', value: information?.language },
    { title: 'Requirement', value: information?.requirement },
    { title: 'Device Name', value: information?.deviceName },
  ]

  return (
    <Flex gap={16} wrap>
      {items
        .filter((item) => item.value)
        .map((item) =>
          isSmall ? (
            <SmallCard key={item.title} title={item.title} value={item.value} />
          ) : (
            <NormalCard
              key={item.title}
              title={item.title}
              value={item.value}
            />
          )
        )}
    </Flex>
  )
}
